import * as React from 'react';
export const dataSvg = React.forwardRef(function dataSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 3.5C2 1.567 4.686 0 8 0s6 1.567 6 3.5v9c0 1.933-2.686 3.5-6 3.5s-6-1.567-6-3.5v-9Zm1.5 0c0-.212.158-.68 1.013-1.18C5.332 1.844 6.561 1.5 8 1.5s2.668.343 3.487.82c.855.5 1.013.968 1.013 1.18 0 .212-.158.68-1.013 1.18-.819.477-2.048.82-3.487.82s-2.668-.343-3.487-.82C3.658 4.18 3.5 3.711 3.5 3.5Zm9 2.315V8c0 .212-.16.681-1.013 1.18-.819.477-2.048.82-3.487.82s-2.668-.343-3.487-.82C3.658 8.68 3.5 8.211 3.5 8V5.815C4.6 6.542 6.208 7 8 7c1.792 0 3.4-.458 4.5-1.185Zm-9 6.685v-2.185C4.6 11.042 6.208 11.5 8 11.5c1.792 0 3.4-.458 4.5-1.185V12.5c0 .211-.158.68-1.013 1.18-.819.477-2.048.82-3.487.82s-2.668-.343-3.487-.82c-.855-.5-1.013-.969-1.013-1.18Z',
    }),
  );
});
dataSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var data = {
  category: 'icon',
  colorable: true,
  name: 'data',
  svg: dataSvg,
};
